
export const InvoiceType = {
  invoiceTypeOptions: [{ label: 'type1', value: 1, active: true },
    { label: 'type2', value: 2, active: true }],
  i18nKey: 'invoiceTypeT',
  zhCn: {
    invoiceTypeT: {
      type1: '增值税专用发票',
      type2: '普通发票'
    }
  },
  en: {
    invoiceTypeT: {
      type1: '增值税专用发票',
      type2: '普通发票'
    }
  }
}
